/* eslint-disable @typescript-eslint/no-explicit-any */
// tslint:disable:no-unused-expression
import { Workflow, WorkflowPage } from '../class/workflow.type';
import { WorkflowRouteGuard } from '../service/workflow/workflow.service';
import { dynamicGuardRegistry } from './dynamic-guard.registry';

export class DynamicGuard {
  private readonly canActivate: any[] = [];
  private readonly canActivateChild: any[] = [];
  private readonly canDeactivate: any[] = [];
  private readonly canLoad: any[] = [];

  constructor(workflow: Workflow, page: WorkflowPage) {
    const workflowGuards = workflow.guards;
    const pageGuards = page.guards;

    const config = pageGuards || workflowGuards || {};
    this.canActivate = this.resolveGuards(config.canActivate);
    this.canActivateChild = this.resolveGuards(config.canActivateChild);
    this.canDeactivate = this.resolveGuards(config.canDeactivate);
    this.canLoad = this.resolveGuards(config.canLoad);
  }

  private resolveGuards(guardNames: string[]): any[] {
    const guards = [];
    for (const guardName of guardNames || []) {
      if (guardName) {
        const guard = this.getGuardInstance(guardName);
        guards.push(guard);
      }
    }
    return guards;
  }

  private getGuardInstance(guardName: string): any {
    const guardRef = dynamicGuardRegistry[guardName];

    if (!guardRef) {
      throw new Error(`Guard name ${guardName} has not been registered.
                        Make sure you add @DynamicGuardService in the service.`);
    }

    return guardRef;
  }

  buildRouteGuard(existingGuard?: WorkflowRouteGuard): WorkflowRouteGuard {
    const final = existingGuard || {};

    final.canActivate = [...(final.canActivate || []), ...this.canActivate];
    final.canActivateChild = [...(final.canActivateChild || []), ...this.canActivateChild];
    final.canDeactivate = [...(final.canDeactivate || []), ...this.canDeactivate];
    final.canLoad = [...(final.canLoad || []), ...this.canLoad];

    return final;
  }
}
